import { useEffect, useRef, useState } from "react";
import justifiedLayout from "justified-layout";
import HeroSection from "./HeroSection";
import Banner from "../../Assets/Images/gallery_banner.png";
import g1 from "../../Assets/Images/galllery/Autograph.png";
import g2 from "../../Assets/Images/galllery/Climate change Book Launch.png";
import g3 from "../../Assets/Images/galllery/Digital publishing house.png";
import g4 from "../../Assets/Images/galllery/Inauguration lamp decor.png";
import g5 from "../../Assets/Images/galllery/National Technology Day.png";
// import g6 from "../../Assets/Images/galllery/Printed by Us & Inaugrated By PMO & Ratan TaTa Sir.png";
import g6 from "../../Assets/Images/galllery/Stage Setup.png";


const imageSources = [g1, g2, g3, g4, g5, g6];

function GalleryTitle() {
    const containerRef = useRef(null);
    const [aspectRatios, setAspectRatios] = useState([]);
    const [containerWidth, setContainerWidth] = useState(0);

    useEffect(() => {
        const loadImages = async () => {
            const ratios = await Promise.all(
                imageSources.map(src =>
                    new Promise(resolve => {
                        const img = new Image();
                        img.src = src;
                        img.onload = () => resolve(img.naturalWidth / img.naturalHeight);
                    })
                )
            );
            setAspectRatios(ratios);
        };
        loadImages();
    }, []);

    useEffect(() => {
        const updateWidth = () => {
            if (containerRef.current) {
                setContainerWidth(containerRef.current.clientWidth);
            }
        };

        updateWidth(); // Initial call
        window.addEventListener("resize", updateWidth);

        return () => window.removeEventListener("resize", updateWidth);
    }, []);

    useEffect(() => {
        if (!aspectRatios.length || !containerRef.current || !containerWidth) return;

        const container = containerRef.current;

        const layout = justifiedLayout(aspectRatios, {
            containerWidth: containerWidth,
            targetRowHeight: 350,
            boxSpacing: 10,
        });

        container.style.position = "relative";
        container.style.height = `${layout.containerHeight}px`;

        Array.from(container.children).forEach((img, index) => {
            const box = layout.boxes[index];
            img.style.position = "absolute";
            img.style.width = `${box.width}px`;
            img.style.height = `${box.height}px`;
            img.style.transform = `translate(${box.left}px, ${box.top}px)`;
        });
    }, [aspectRatios, containerWidth]);

    return (
        <div className="gallery-title">
            <HeroSection image={Banner} pageTitle="Gallery" />

            <section className="d-flex flex-column justify-content-center align-items-center text-center">
                <div className="container">
                    <h2>"Captured Moments & Memories"</h2>
                    <p className="mt-4 fw-light">
                        Every event is a story, and we bring those stories to life through unforgettable moments. Explore our gallery and relive the magic of seamlessly executed, picture-perfect events.
                    </p>
                </div>
            </section>

            <section className="container-fluid mt-5">
                <div ref={containerRef} className="gallery-container">
                    {imageSources.map((src, index) => (
                        <div key={index} className="image-wrapper">
                            <img
                                src={src}
                                alt={`Gallery ${index + 1}`}
                                className="gallery-image"
                            />
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}

export default GalleryTitle;
